import { render, staticRenderFns } from "./purchase_order_wait_delivery_list.vue?vue&type=template&id=3b984e2f&scoped=true"
import script from "./purchase_order_wait_delivery_list.vue?vue&type=script&lang=js"
export * from "./purchase_order_wait_delivery_list.vue?vue&type=script&lang=js"
import style0 from "./purchase_order_wait_delivery_list.vue?vue&type=style&index=0&id=3b984e2f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b984e2f",
  null
  
)

export default component.exports